import { Moment } from 'moment';

import { Account } from '../account/account.model';
import { Thread } from '../conversational/thread.model';
import { FileLink } from '../file-link.model';
import { FocusRange } from '../focus-range.model';
import { Invoice } from '../invoice/invoice.model';
import { NotificationCategory } from '../types/notification-category';
import { NotificationEventType } from '../types/notification-event-type';
import { NotificationPriority } from '../types/notification-priority';
import { NotificationStatus } from '../types/notification-status';

export class Icon {
  icon: string;
  tooltip: string;
}

/**
 * Model for API Notification Model
 */
export abstract class WattsonNotification {
  /**
   * Auto-generated identifier.
   */
  id: number;

  /**
   * Accounts concerned by the notification
   */
  accounts: Account[];

  /**
   * The notification has been sent by a bot
   */
  sentByBot: boolean;

  /**
   * Category of the notification
   */
  category: NotificationCategory;

  /**
   * Event Type of the notification
   */
  eventType: NotificationEventType;

  /**
   * Date of creation of the notification.
   */
  createdAt: Moment;

  /**
   * Priority of the notification
   */
  priority: NotificationPriority;

  /**
   * Status of the notification.
   */
  status: NotificationStatus;

  /**
   * The target of the notification.
   */
  target: Invoice | Thread | FileLink;

  constructor(attributes: Partial<WattsonNotification> = {}) {
    Object.assign(this, attributes);
  }

  isRemoteLink() {
    return false;
  }

  getNotificationMessageParams() {
    return {};
  }

  getNotificationMessage(): string {
    return this.eventType ? `notification_panel.${this.category}.${this.eventType}` : null;
  }

  getAlertMessage(): string {
    return undefined;
  }

  isNewNotification() {
    return this.status === NotificationStatus.new;
  }

  abstract getIcons(): Icon[];

  abstract getTypeIcon(): string;

  abstract getNotificationAuthor(): string;

  abstract getFocus(): FocusRange[];

  abstract getLink(): string;
}
